import { create } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';
import { User, UserRole } from 'types/api.d';

export interface UserStore extends User {
  setUser: (user: User) => void;
  resetUser: () => void;
}

const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      id: 0,
      email: '',
      image_url: '',
      role: UserRole.MEM,
      position: '',
      assistant_name: '',
      gender: '',
      communication_style: '',
      full_name: '',
      company: null,
      setUser: (user: User) => {
        set(() => ({ ...user }));
      },
      resetUser: () => {
        set(() => ({
          id: 0,
          email: '',
          image_url: '',
          role: UserRole.MEM,
          position: '',
          assistant_name: '',
          gender: '',
          communication_style: '',
          full_name: '',
          company: null,
        }));
      },
    }),
    {
      name: 'user-storage',
      getStorage: () => localStorage,
    } as PersistOptions<UserStore>
  )
);

export { useUserStore };
